import { render, staticRenderFns } from "./madePaper.vue?vue&type=template&id=30b05e9c&scoped=true"
import script from "./madePaper.vue?vue&type=script&lang=js"
export * from "./madePaper.vue?vue&type=script&lang=js"
import style0 from "./madePaper.vue?vue&type=style&index=0&id=30b05e9c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b05e9c",
  null
  
)

export default component.exports